import LM from './LM';

export default LM;
